import React, { useState } from 'react'
import { getBackgroundColor, getFormatedWeb3Address, formatSmartDecimal } from '../../utils/helpers'
import { useTheme } from '../../contexts/ThemeProvider'
import { useTranslation } from 'react-i18next'
import { DARK_THEME, MARKET_V3, RESOLVER } from '../../utils/constants'
import DisputeTimer from './DisputeTimerUi';
import { Modal } from 'react-bootstrap'
import { userSmartAccount } from '../RecoilAtom'
import { useRecoilValue } from 'recoil'

const MarketOutcome = ({ winnerData, poolsdetail, setShowEvidence, setShowEvidenceHistory, timeExtendUi, extendDisputeTimer, publicPoolResolverAddress, disputeTimer, setDisputeTimer, reSubmitOrFinalizeSpinner, revealWinner, revealWinnerUi, showresubmit, setShowResubmit, handleEstimateReSubmitAppealGas, poolUnderDisputeUi, poolDisputed, isAppealed, oracleExtendedTimeNo, gasEstimateInUsdt, gasFeesSpinner, handleEstimateFinalizeWinnerGas, hasTooEarlyHistory }) => {
    const { theme } = useTheme()
    const { t } = useTranslation()
    const smartAccount = useRecoilValue(userSmartAccount);
    const decidedByResolver = poolsdetail?.winnerOption?.decidedBy === RESOLVER
    const [finalizeMode, setFinalizeMode] = useState(false);
    const isCurrentUserAppealer = poolsdetail?.appealData?.senderWalletAddress?.toLowerCase() === smartAccount?.toLowerCase();

    const handleConfirmAction = async () => {
        if (finalizeMode) {
            await revealWinner();
        } else {
            await extendDisputeTimer();
        }
    };

    return (
        <>
            <div className="market-outcome">
                <h5 className="head-text">Market Outcome</h5>
                <div className="outcomes-box">
                    <h6>
                        <span
                            style={{
                                backgroundColor: getBackgroundColor(
                                    poolsdetail?.options?.findIndex(opt => opt._id === winnerData?.winnerId),
                                    theme,
                                    poolsdetail?.options?.length
                                )
                            }}
                            className='circle-dot'
                        ></span>
                        {winnerData?.winnerOption}
                    </h6>
                </div>
                {poolsdetail?.version >= MARKET_V3 && (
                    <>
                        <div className="winnerdecideui p-0">
                            <div className="decidedby mb-0">
                                <p>{t("Decided By")}</p>
                                {decidedByResolver ? (
                                    <div className="specific-participant">
                                        <img src={poolsdetail?.winnerProposer?.user?.profilePic} alt="img" className='img-fluid' />
                                        <h6>
                                            {poolsdetail?.winnerProposer?.user?.name || getFormatedWeb3Address(poolsdetail?.winnerProposer?.user?.walletAddress, true)}
                                            <span>{poolsdetail?.winnerProposer?.role}</span>
                                        </h6>
                                    </div>
                                ) : (
                                    <h6 style={{ color: "var(--heading-text)" }}>
                                        <img
                                            src={theme === 'dark' ? "/assets/olympus-outcomedark.svg" : "/assets/olympus-outcome.svg"}
                                            alt="img"
                                            className='img-fluid'
                                        />
                                    </h6>
                                )}
                            </div>
                        </div>
                    </>
                )}
                {(timeExtendUi || poolUnderDisputeUi) && poolDisputed && isAppealed && (
                    <>
                        <div className="raised-dispute">
                            <div className="upper-text">
                                {
                                    timeExtendUi ? <><h6>Human Review Delayed</h6>
                                        <p>Ethos did not return a decision within the expected time. </p></> :
                                        <>
                                            <h6>{isCurrentUserAppealer ? 'Your appeal is under review.' : 'An Appeal has been submitted'}</h6>
                                            <p>Appeal Review by {
                                                theme === DARK_THEME ? <img src='/assets/olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} /> :
                                                    <img src='/assets/olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} />
                                            } </p>
                                        </>

                                }
                            </div>
                            {timeExtendUi ? (
                                <>
                                    <button
                                        onClick={() => { setFinalizeMode(false); handleEstimateReSubmitAppealGas(); }}
                                        className="btn-dispute btn-extendtimer"
                                        style={{ marginBottom: "0" }}
                                        disabled={!smartAccount}
                                    >
                                        <h6>Resubmit Appeal</h6>
                                    </button>
                                    <p className='resubmission-text'>Resubmission attempt {oracleExtendedTimeNo ?? 0} of 7</p>
                                </>
                            ) : (
                                <>
                                    <div className="disputeinreview">
                                        <p>Appeal Resolution In</p>
                                        <DisputeTimer
                                            disputeTimer={disputeTimer}
                                            setDisputeTimer={setDisputeTimer}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                )}



                {
                    revealWinnerUi && (
                        <div className="raised-dispute humanreview-completed">
                            <div className="upper-text">
                                <h6>Human Review Completed</h6>
                                <p>Ethos has returned a final decision for this market.</p>
                            </div>
                            <button onClick={() => { setFinalizeMode(true); handleEstimateFinalizeWinnerGas(); }} className='btn-dispute btn-extendtimer' style={{ marginBottom: "0" }}>
                                <h6>Finalize Decision</h6>
                            </button>
                            <div className="upper-text mt-3 pb-0">
                                <p className='text-center' style={{ fontSize: "14px" }}>Finalizing will publish the decision on-chain and close the market.
                                    This action requires a network gas fee.</p>
                            </div>
                        </div>
                    )
                }

                {
                    hasTooEarlyHistory ? <p className="bottom-para mt-2">
                        <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View Proposed Resolutions History</a>
                    </p> : <p className="bottom-para mt-2">
                        Review full resolution history.{' '}
                        <a onClick={() => { setShowEvidence(true); setShowEvidenceHistory(true); }}>View History</a>
                    </p>
                }

                {
                    hasTooEarlyHistory && (
                        <div className="too-early-case-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <g clip-path="url(#clip0_3917_4189)">
                                    <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 12V9" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 6H9.0075" stroke="#797979" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_3917_4189">
                                        <rect width="18" height="18" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <p>The last resolution attempt was submitted too early. The market remains open and available for resolution.</p>
                        </div>
                    )
                }
            </div>

            <Modal
                className="detail privatepollmodal dispute-create-modal resubmit-appeal-modal"
                show={showresubmit}
                onHide={() => setShowResubmit(false)}
                centered
                backdrop="static"
            >
                <Modal.Body>
                    <div className="dispute-create-parent">
                        <div className="upper-icon icongrey">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M31.5 22.8765C32.2667 21.8842 32.7419 20.6979 32.8722 19.4507C33.0025 18.2034 32.7827 16.9445 32.2376 15.8152C31.6925 14.6858 30.8435 13.7307 29.7859 13.0568C28.7283 12.3829 27.5039 12.017 26.25 12H23.565C23.1377 10.5738 22.412 9.25472 21.436 8.13036C20.46 7.00599 19.2561 6.10205 17.9041 5.4785C16.5521 4.85496 15.0829 4.52607 13.5941 4.51367C12.1053 4.50127 10.6309 4.80563 9.26866 5.40657C7.90645 6.00751 6.68762 6.89127 5.69304 7.99922C4.69846 9.10717 3.95088 10.414 3.49991 11.8329C3.04893 13.2518 2.90488 14.7504 3.0773 16.2293C3.24972 17.7081 3.73468 19.1334 4.49999 20.4105" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.5 16.5V22.5H16.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 28.5C12.9445 29.7593 14.2612 30.6895 15.7637 31.1589C17.2663 31.6282 18.8784 31.6129 20.3717 31.1151C21.865 30.6173 23.1639 29.6623 24.0843 28.3853C25.0047 27.1083 25.5 25.5741 25.5 24C25.5 22.2098 24.7888 20.4929 23.523 19.227C22.2571 17.9612 20.5402 17.25 18.75 17.25C17.8003 17.2493 16.8597 17.4357 15.9821 17.7986C15.1044 18.1615 14.3069 18.6938 13.635 19.365L10.5 22.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <h4>{finalizeMode ? 'Finalize Market Resolution?' : 'Resubmit Appeal?'}</h4>
                        <p className="para">
                            {finalizeMode ? (
                                <>Ethos has returned a final decision.<br />By continuing, the result will be published on-chain and the market will move to Final Resolution.</>
                            ) : (
                                <>The human review process did not return a decision in time.<br />By continuing, the appeal will be submitted again to Ethos.</>
                            )}
                            <br /><br />This action requires a network gas fee.
                        </p>
                        <div className="outcomes-parent">
                            <div className="single">
                                <div className="bottom p-0">
                                    <p>network fee:</p>
                                    <h6>
                                        {gasFeesSpinner
                                            ? <span className="spinner" />
                                            : `$${formatSmartDecimal(gasEstimateInUsdt) || '—'}`
                                        }
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="twice-btns">
                            <button className="btn-cancel" onClick={() => setShowResubmit(false)}>Cancel</button>
                            <button
                                className="btn-dispute"
                                disabled={gasFeesSpinner || reSubmitOrFinalizeSpinner}
                                onClick={handleConfirmAction}
                            >
                                {(gasFeesSpinner || reSubmitOrFinalizeSpinner) ? 'Loading...' : finalizeMode ? 'Confirm & Finalize' : 'Confirm & Pay Gas'}
                            </button>
                        </div>

                    </div>

                </Modal.Body>
            </Modal>

        </>
    )
}

export default MarketOutcome
